import { render, staticRenderFns } from "./Estudiantes.vue?vue&type=template&id=1eec7d7e"
import script from "./Estudiantes.vue?vue&type=script&lang=js"
export * from "./Estudiantes.vue?vue&type=script&lang=js"
import style0 from "./Estudiantes.vue?vue&type=style&index=0&id=1eec7d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports